import DeleteUser from './DeleteUser';
import DeleteUserResult from './DeleteUserResult';

export { DeleteUserResult };

export default DeleteUser;
